import { selectIsInternalAdmin } from 'accessors'
import { useSelector } from 'react-redux'

function useCanSeeGroupToggle() {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const hasGroupViewAccess = useSelector(s => s.billing.hasGroupViewAccess)

  return isInternalAdmin || hasGroupViewAccess
}

export default useCanSeeGroupToggle
